import errorTemplate from '../error-template';

export default response => {
  const {status, statusText} = response;

  throw errorTemplate(status, statusText);
};
